import { get, readable, writable } from "svelte/store";
import { State } from "./State";
export class Section {
    constructor(form, id, name, description, status, position, required, width, parentId, date_created, date_updated, date_disabled, questions
    // public readonly parentQuestion: Question | null = null
    ) {
        this.form = form;
        this.id = id;
        this.parentId = parentId;
        this.date_created = date_created;
        this.date_updated = date_updated;
        this.date_disabled = date_disabled;
        this.questionsWritable = writable([]);
        this.questionsReadable = readable([], set => this.questionsWritable.subscribe(set));
        this.name = new State(name);
        this.description = new State(description);
        this.status = new State(status);
        this.position = new State(position);
        this.required = new State(required);
        this.width = new State(width);
        for (const question of questions) {
            this.addQuestion(question);
        }
    }
    get questions() {
        return [...get(this.questionsWritable)];
    }
    addQuestion(question) {
        if (this.hasQuestionId(question.id)) {
            return;
        }
        const questions = [...this.questions, question];
        this.updateQuestionPositions(questions);
        this.questionsWritable.set(questions);
    }
    prependQuestion(question) {
        if (this.hasQuestionId(question.id)) {
            return;
        }
        const questions = [question, ...this.questions];
        this.updateQuestionPositions(questions);
        this.questionsWritable.set(questions);
    }
    quitQuestion(questionId) {
        if (!this.hasQuestionId(questionId)) {
            return;
        }
        const questions = this.questions.filter(({ id }) => id !== questionId);
        this.updateQuestionPositions(questions);
        this.questionsWritable.set(questions);
    }
    moveUp(question) {
        const { questions } = this;
        const index = questions.findIndex(({ id }) => id === question.id);
        if (index === 0) {
            return;
        }
        questions.splice(index, 1);
        questions.splice(index - 1, 0, question);
        this.updateQuestionPositions(questions);
        this.questionsWritable.set(questions);
    }
    moveDown(question) {
        const { questions } = this;
        const index = questions.findIndex(({ id }) => id === question.id);
        if (index === questions.length - 1) {
            return;
        }
        questions.splice(index, 1);
        questions.splice(index + 1, 0, question);
        this.updateQuestionPositions(questions);
        this.questionsWritable.set(questions);
    }
    remove() {
        this.form.quitSection(this.id);
    }
    toJSON() {
        return {
            id: this.id,
            formId: this.form.id,
            name: this.name.value,
            description: this.description.value,
            status: this.status.value,
            position: this.position.value,
            required: this.required.value,
            width: this.width.value,
            parentId: this.parentId,
            date_created: this.date_created,
            date_updated: this.date_updated,
            date_disabled: this.date_disabled,
            questions: this.questions,
        };
    }
    hasQuestionId(questionId) {
        return this.questions.some(({ id }) => id === questionId);
    }
    updateQuestionPositions(questions) {
        questions.forEach((question, index) => question.position.set(index));
    }
}
